var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 48,
    viewBox: "0 0 194 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1670_930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1122 15.7271V36.9617H62.2039V15.7271V14.9083H63.0294H70.4124V11.0692H48.8806V14.9083H56.2868H57.1122V15.7271Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.763 33.1458H104.149H103.323V32.3192V26.7653V25.9388H104.149H113.399V22.0766H104.149H103.323V21.25V15.6961V14.8696H104.149H116.763V10.9996H98.2549V36.9926H116.763V33.1458Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.498 25.7149L123.791 11.0692H118.552L132.246 36.6605L146.001 11.0692H140.686L132.956 25.7149L132.223 27.0975L131.498 25.7149Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.11 32.3192V26.7653V25.9388H154.935H164.185V22.0766H154.935H154.11V21.25V15.6961V14.8696H154.935H167.541V10.9996H149.041V36.9926H167.541V33.1458H154.935H154.11V32.3192Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.228 24L184.552 23.5288L193.231 11.0692H187.522L182.052 18.9018L181.373 19.8674L180.702 18.9018L175.24 11.0692H169.539L178.172 23.5288L178.503 24L178.172 24.4712L169.531 36.9463L175.24 36.9617L180.694 29.0982L181.373 28.1249L182.052 29.0982L187.53 36.9617H193.231L184.552 24.4712L184.228 24Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5882 27.0203C90.3781 26.441 91.1572 25.9466 92.2219 24.7184C93.5102 23.2198 94.1351 21.6827 94.1351 20.0142V19.2958C94.1351 16.5922 93.1476 15.2791 91.2035 13.6801C89.136 11.9962 86.2121 11.0692 82.9796 11.0692H72.8965L72.9196 36.9617H77.9882V24.1545H77.9651V14.9006H82.563C84.4609 14.9006 86.243 15.3872 87.2227 16.1751H87.2382L87.2459 16.1906C88.3182 17.1175 88.8583 18.2144 88.8583 19.4657C88.8583 22.0612 86.5053 24.17 83.62 24.17H80.5572V24.1545H78.7211L79.4617 25.0892L88.812 36.954H94.9297L88.1948 28.3103L87.4696 27.3833L88.5882 27.0203Z",
    fill: "#162F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4538 32.5897H22.1182V47.9923L44.2209 25.8617C36.915 24.9502 30.3035 24.5562 24.4634 24.4867L26.4538 32.582V32.5897Z",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.1461C4.40511 22.9417 11.1324 23.8146 19.904 23.9691L20.012 23.5365C18.6851 22.795 17.7824 21.3737 17.7824 19.7438C17.7824 17.3492 19.7266 15.4026 22.1181 15.4026V0",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.118 48V32.5974H17.7824L19.7728 24.5176C11.3328 24.6721 4.79847 25.4986 0.416504 26.271L14.6425 31.5005L22.1257 48.0078L22.118 48Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4538 19.7515C26.4538 21.3814 25.5589 22.8027 24.2243 23.5443L24.3323 23.9923C30.3189 23.9305 37.1156 23.5211 44.6452 22.5632L29.5937 16.5072L22.1182 0V15.4104C24.5097 15.4104 26.4538 17.3569 26.4538 19.7515Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6529 22.5632L22.1182 0L29.6014 16.5072L44.6529 22.5632Z",
    fill: "url(#paint0_linear_1670_930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6529 22.5632L22.1182 0L29.6014 16.5072L44.6529 22.5632Z",
    fill: "#E2833D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6349 31.4928L0.408936 26.2633L22.1182 48L14.6349 31.4928Z",
    fill: "url(#paint1_linear_1670_930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6349 31.4928L0.408936 26.2633L22.1182 48L14.6349 31.4928Z",
    fill: "#E2833D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1670_930",
    x1: 30.1801,
    y1: 24.7029,
    x2: 33.5208,
    y2: 10.7312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1670_930",
    x1: 17.4122,
    y1: 25.8925,
    x2: 11.1202,
    y2: 37.3644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1670_930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193.231,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d903c4b7e46716a3a20eed02d95fb2b9.svg";
export { ForwardRef as ReactComponent };